import { api } from './api';

export type AssemblyCategory = {
  id: number;
  name: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  _count?: {
    assemblies: number;
  };
};

export type AssemblyCategoryWithAssemblies = AssemblyCategory & {
  assemblies: { id: number; name: string }[];
};

export const getAssemblyCategories = async (): Promise<AssemblyCategory[]> => {
  const { data } = await api.get<AssemblyCategory[]>('/assembly-category');
  return data;
};

export const getAssemblyCategory = async (id: number): Promise<AssemblyCategoryWithAssemblies> => {
  const { data } = await api.get<AssemblyCategoryWithAssemblies>(`/assembly-category/${id}`);
  return data;
};

export const createAssemblyCategory = async (name: string): Promise<AssemblyCategory> => {
  const { data } = await api.post<AssemblyCategory>('/assembly-category', { name });
  return data;
};

export const updateAssemblyCategory = async (
  id: number,
  name: string,
): Promise<AssemblyCategory> => {
  const { data } = await api.patch<AssemblyCategory>('/assembly-category', { id, name });
  return data;
};

export const deleteAssemblyCategory = async (id: number): Promise<void> => {
  await api.delete(`/assembly-category/${id}`);
};

export const reorderAssemblyCategories = async (
  categoryIds: number[],
): Promise<AssemblyCategory[]> => {
  const { data } = await api.patch<AssemblyCategory[]>('/assembly-category/reorder', {
    categoryIds,
  });
  return data;
};
